import { CampaignDetails, Player } from "@/lib/types";
import { getCampaignArea, getPlayer, getPlayerCampaign } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { AssignedPlayersRenderer } from "@/pages/player/shared/AssignedPlayersRenderer";
import { LoadingSmall } from "@/components/LoadingSmall";
import { NestedAreaSelector } from "@/components/NestedAreaSelector";
import { useTranslation } from "react-i18next";

interface Props {
  campaignDetails: CampaignDetails;
}

export const CampaignDetailAssignedPlayers = ({ campaignDetails }: Props) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  const { data: campaignAreas, isLoading: isCampaignAreasLoading } = useQuery({
    queryKey: ["getCampaignArea", campaignDetails.intId],
    queryFn: () => getCampaignArea(campaignDetails.id, String(activeFirm?.firmGuid)),
  });

  const campaignAreasData = campaignAreas?.data.result || [];

  if (isCampaignAreasLoading) {
    return <LoadingSmall />;
  }

  return (
    <div className="border border-dashed p-4 rounded-md">
      <div className="text-sm mb-4 mb-2">{t("common.assignedPlayers")}</div>
      <NestedAreaSelector
        disabled
        selectedAreaIds={campaignAreasData.map((r) => r.areaintId)}
        onSelectionChange={() => {}}
        showPlayers
      />
    </div>
  );
};
